import { getAccordionAnchorById } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionSelectors";
import { AccordionAnchorModel } from "@toolkit/Framework/Store/Toolkit/Components/Accordion/AccordionTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface CreateAccordionAnchorParameter extends AccordionAnchorModel {}

type HandlerType = Handler<CreateAccordionAnchorParameter>;

export const DispatchCreateAccordionAnchor: HandlerType = props => {
    const anchor = getAccordionAnchorById(props.getState(), props.parameter.id);

    if (!anchor) {
        props.dispatch({
            type: "Toolkit/Components/Accordion/CreateAccordionAnchor",
            id: props.parameter.id,
            isOpen: props.parameter.isOpen,
        });
    }
};

export const chain = [DispatchCreateAccordionAnchor];

const createAccordionAnchor = createHandlerChainRunner(chain, "CreateAccordionAnchor");

export default createAccordionAnchor;
